<!--
 * @Author: wbf
 * @LastEditTime: 2022-09-21 17:50:57
 * @Description: 账号激活
-->
<template>
	<div>
		<router-view />
	</div>
</template>

<script>
export default {
	name: "Activate",
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>

<style lang="scss" scoped></style>
